export default __webpack_public_path__ + "static/media/ruby.41bcfc15.svg";